import React, { Component } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

// Array de redes sociales (manteniendo solo Instagram como en el original)
const SocialShare = [
  // { Social: <FaFacebookF />, link: "https://www.facebook.com/" },
  // { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/aescobarem_/" }, // Mantenido link original
  // { Social: <FaTwitter />, link: "https://twitter.com/" },
];

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer-area">
          <div className="footer-wrapper">
            <div className="row align-items-end row--0" >
              {/* Sección Izquierda del Footer */}

              <div className="col-lg-6">
                <div className="footer-left">
                  <div className="inner">
                    {/* Texto motivacional traducido */}
                    <span>¿Listo/a Para Empezar?</span>
                    <h2>
                      {/* Título principal traducido */}
                      Manos <br /> a la obra
                    </h2>
                    {/* Botón de contacto traducido */}
                    <a className="rn-button-style--2" href="https://api.whatsapp.com/send?phone=584244560374">
                      <span>Contáctanos</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Sección Derecha del Footer */}
              <div className="col-lg-6" >
                <div className="footer-right" data-black-overlay="5" style={{backgroundImage: "url(https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg)" }}>
                  <div className="row">
                    {/* Inicio Widget Individual (Enlaces Rápidos) */}
                    {/* <div className="col-lg-6 col-sm-6 col-12">
                      <div className="footer-link">
                   
                        <h4>Enlaces Rápidos</h4>
                        <ul className="ft-link">
                          <li>
                          
                            <a href="/portfolio">Portafolio</a>
                          </li>
                          <li>
                     
                            <a href="/about">Nosotros</a>
                          </li>
                          <li>
                          
                            <a href="/contact">Hablemos</a>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                    {/* Fin Widget Individual (Enlaces Rápidos) */}

                    {/* Inicio Widget Individual (Contacto y Redes) */}
                    <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30" >
                   
                      <div className="footer-link">
                        {/* Título traducido */}
                        <h4>Escríbenos</h4>
                        <ul className="ft-link">
                          <li style={{color: "#ada9b2"}}>
                          ¿Listo/a para impulsar tu marca? Estamos entusiasmados por escuchar sobre tus nuevos proyectos y listos para resolver cualquier duda que tengas. Ponte en contacto con nosotros. ¡Estamos aquí para ayudarte a alcanzar tus metas!
                          </li>
                          <li>
                            {/* Correo de ejemplo (mantenido) */}
                            <a href="mailto:escobarmartinez14@gmail.com">escobarmartinez14@gmail.com</a>
                          </li>
                        </ul>

                        {/* Sección de Redes Sociales */}
                        <div className="social-share-inner">
                          <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                            {SocialShare.map((val, i) => (
                              <li key={i}>
                                <a target="_blank" rel="noopener noreferrer" href={`${val.link}`}>{val.Social}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* Fin Widget Individual (Contacto y Redes) */}

                  </div>
                </div>
              </div>

            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
export default Footer;